<template>
<div id="report-style" >
  <a href="javascript:window.print()" class="print-button">Print Report</a>
  <div id="report-to-print" class="d-flex .flex-*-fill flex-column bd-highlight">
    <div id="report-head" class="d-flex flex-column bd-highlight">
      <div id="report-title" class="d-flex flex-row bd-highlight">
        <div class="p-2 flex-grow-1  bd-highlight">Report of Master Sample Request</div>
        <div class="p-2 bd-highlight">{{moment(rs.startDate).format("dddd, MMMM Do, YYYY")}}</div>
      </div>
      <div class="d-flex flex-row bd-highlight">
        <div id="report-image" alt="logo"></div>
        <div id="report-header" class="d-flex flex-fill flex-column bd-highlight">
          <div class="p-2 bd-highlight"><b>PT. UNILEVER OLEOCHEMICAL INDONESIA</b></div>
          <div class="p-2 bd-highlight"><b><i>FORM PEMESANAN SAMPLE</i></b></div>
          <div class="p-2 bd-highlight"><b><i>FORM SAMPLE REQUEST</i></b></div>
        </div>
        <div id="report-sidebar" class="d-flex flex-fill flex-column bd-highlight">
          <div id="sidebar-border" class="p-1 bd-highlight">No Dok<br/>Doc No</div>
          <div id="sidebar-border" class="p-1 bd-highlight">No Terbitan<br/>Issue No</div>
          <div id="sidebar-border" class="p-1 bd-highlight">Halaman No<br/>Page No</div>
        </div>
        <div id="report-sidebar" class="d-flex flex-fill flex-column bd-highlight">
          <div id="sidebar-border" class="p-1 bd-highlight"><br/>UOI -F-TS-012</div>
          <div id="sidebar-border" class="p-1 bd-highlight"><br/>01.1</div>
          <div id="sidebar-border" class="p-1 bd-highlight"><br/>1 of 1</div>
        </div>
      </div>
    </div>

    <div id="report-body" class="d-flex justify-content-between">
      <div class="d-flex flex-row bd-highlight">
        <div class="p-2 bd-highlight"><b>SR Number</b></div>
        <div class="p-2 bd-highlight">: {{rs.srNumber}}</div>
      </div>
      <!-- <div class="d-flex flex-row bd-highlight">
        <div class="p-2 bd-highlight"><b>Date</b></div>
        <div class="p-2 bd-highlight">: {{moment(rs.startDate).format("M/DD/YYYY")}}</div>
      </div> -->
    </div>

    <div id="report-body" class="d-flex justify-content-between">
      <div class="d-flex flex-row bd-highlight">
        <div class="p-2 bd-highlight"><b>Date</b></div>
        <div class="p-2 bd-highlight">: {{moment(rs.startDate).format("M/DD/YYYY")}}</div>
      </div>
      <!-- <div class="d-flex flex-row bd-highlight ">
        <div class="p-2 bd-highlight"><b>Product</b></div>
        <div class="p-2 bd-highlight flex-wrap">: {{rs.product}}</div>
      </div>
      <div class="d-flex flex-row bd-highlight">
        <div class="p-2 bd-highlight"><b>Customer Type</b></div>
        <div class="p-2 bd-highlight flex-wrap">: {{rs.customer}}</div>
      </div> -->
    </div>

    <div id="report-table">
      <table class="table table-bordered table-sm">
        <thead>
          <tr>
            <th scope="col">Request Date</th>
            <th scope="col">Customer</th>
            <th scope="col">Product</th>
            <th scope="col">Quantity</th>
            <th scope="col">Spec Name</th>
            <th scope="col">Address</th>
            <th scope="col">Contact Person</th>
            <th scope="col">Purpose</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(list, index) in rs.requestSampleDetail" v-bind:key="index">
            <td v-if="index==0" :rowspan="rs.requestSampleDetail.length">{{moment(rs.startDate).format("M/DD/YYYY")}}</td>
            <td v-if="index==0" :rowspan="rs.requestSampleDetail.length">{{rs.customer}}</td>
            <td>{{rs.product}}</td>
            <td>{{list.qty}}</td>
            <td>{{list.remark}}</td>
            <td v-if="index==0" :rowspan="rs.requestSampleDetail.length">{{rs.destination}}</td>
            <td v-if="index==0" :rowspan="rs.requestSampleDetail.length">Contact Person</td>
            <td v-if="index==0" :rowspan="rs.requestSampleDetail.length">Purpose</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div id="report-body" class="d-flex justify-content-between">
      <div class="d-flex flex-row bd-highlight">
        <div class="p-2 bd-highlight"><b>Remarks</b></div>
        <div class="p-2 bd-highlight">: {{rs.remark}}</div>
      </div>
    </div>

    <div id="report-footer" class="d-flex justify-content-between">
      <div class="d-flex flex-row bd-highlight">
        <div class="p-2 bd-highlight"><b>Sales Admin</b></div>
      </div>
      <div class="d-flex flex-row bd-highlight">
        <div class="p-2 bd-highlight"><b>Assistant Sales Manager</b></div>
      </div>
    </div>

    <!-- <app-datatable :type="'input'" :newData="newDetailGantt" :elements="dtElementsGantt" :collections="rs.requestSampleGanttChart"></app-datatable> -->
    <app-gantt :tasks="rs.requestSampleGanttChart"></app-gantt>

    <!-- <div id="report-body" class="d-flex justify-content-between">
      <div class="d-flex flex-row bd-highlight">
        <app-gantt :tasks="rs.requestSampleGanttChart"></app-gantt>
      </div>
    </div> -->
    
    <!-- <div id="report-header" class="d-flex flex-row bd-highlight">
      <div class="p-2 bd-highlight">Flex item 1</div>
      <div class="p-2 bd-highlight">Flex item 2</div>
      <div class="p-2 bd-highlight">Flex item 3</div>
    </div> -->
  </div>
</div>
</template>

<script>
import moment from 'moment'
import api from '../../services/api'
import { requestSample, requestSampleDetail, requestSampleGanttChart } from '../../models/reportRequestSamplePartial'
import AppLookupField from '../../components/AppLookupField.vue'
import AppDatatable from '../../components/AppDatatable.vue'
import AppDatePicker from '../../components/AppDatePicker.vue'
import AppGantt from '../../components/AppGantt.vue';
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'

export default {
  components: {
    AppLookupField, AppDatatable, AppDatePicker, AppGantt
  },
  data() {
    return {
      mode: 'day',
      tasks: [
        {
          sequence: '1',
          name: 'Testing project gantt 1 - Testing project gantt 1',
          start: '2019-01-01',
          end: '2019-01-05',
          // dependencies: '0'
        },
        {
          sequence: '2',
          name: 'Testing project gantt 2 - Testing project gantt 2',
          start: '2019-01-05',
          end: '2019-01-10',
          // progress: 20,
          // dependencies: '1'
        },
        {
          sequence: '3',
          name: 'Testing project gantt 3 - Testing project gantt 3',
          start: '2019-01-10',
          end: '2019-01-15',
          // progress: 30,
          // dependencies: '2'
        },
        {
          sequence: '4',
          name: 'Testing project gantt 4',
          start: '2019-01-15',
          end: '2019-01-20',
          // progress: 40,
          // dependencies: '3'
        }
      ],
      rs: {
        ...requestSample,
        requestSampleDetail: [],
        requestSampleGanttChart: []
      },
      newDetailGantt: requestSampleGanttChart ,
      dtElementsGantt: [
        {
          title: 'Gantt Chart Name',
          column: 'name',
          type: 'text',
          width: 15,
        },
        {
          title: 'Start Date',
          column: 'start',
          type: 'date',
          width: 5,
        },
        {
          title: 'End Date',
          column: 'end',
          type: 'date',
          width: 5,
        }
      ]
    }
  },
  async created() {
    if(this.$route.query.id !== undefined) {
      const rsApi = api('print/request-sample')
      this.rs = await rsApi.getWithParams(this.$route.query.id)
    }
  },
  methods: {
    close() {
      this.$router.push({ name: 'approvedQuality' })
    },
    finishLookup(data) {
      const currentSR = this.rs
      this.rs = {
          ...currentRS,
          ...data
      }
    },
    renderGantt() {
      const newGantt = this.rs.requestSampleGanttChart
      this.rs.requestSampleGanttChart.splice(0, this.rs.requestSampleGanttChart.length, ...newGantt)
    },
    async exportToPdf() {
      const input = document.getElementById('report-to-print')
      const canvas = await html2canvas(input, {
        width: 1450,
        height: 1000
      })
      const imgData = canvas.toDataURL('image/png')

      const pdf = new jsPDF('l', 'mm', 'a4')
      const pdfWidth = pdf.internal.pageSize.getWidth()
      const pdfHeight = pdf.internal.pageSize.getHeight()

      const currentTime = Date.now()
      pdf.addImage(imgData, 'JPEG', 0, 0, pdfWidth, pdfHeight)
      pdf.save(`${this.rs.srNumber}.pdf`)
    }
  }
}
</script>